module.exports = __webpack_public_path__ + "img/banner3_1_th.36a10f6d.png";